import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { orderKeys } from '../orderQueryKeys'
import { placeOrder } from '../orderEndpoints'

export function usePlaceOrderMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: placeOrder,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: orderKeys.histories() })
    },
  })
}
